import { createSlice } from '@reduxjs/toolkit';

import { isRestaurantApp } from '../../../../../../util/Helpers';
import { getConfig } from '../../../../../../AppConfig';

const config = getConfig();

const defaultSelectedRestaurantValue = isRestaurantApp()
  ? config?.profileKey
  : null;

const defaultSelectedRestaurantDetailsId = isRestaurantApp()
  ? config?.restaurantId
  : null;

export const INITIAL_STATE = {
  selectedRestaurantId: defaultSelectedRestaurantValue as string | null,
  selectedRestaurantDetailsId: defaultSelectedRestaurantDetailsId as
    | number
    | null,
  selectedRestaurantData: null as any,
  selectedRestaurantMenu: null as any,
  restaurantDetailsError: false as boolean,
  restaurantDetailsLoaded: false as boolean,
};

const mainSlice = createSlice({
  name: 'restaurant',
  initialState: { ...INITIAL_STATE },
  reducers: {
    setSelectedRestaurantId(state, action) {
      const profileKey =
        action.payload && typeof action.payload === 'object'
          ? action.payload.profileKey
          : action.payload;
      const restaurantId =
        action.payload &&
        typeof action.payload === 'object' &&
        Object.prototype.hasOwnProperty.call(action.payload, 'restaurantId')
          ? action.payload.restaurantId
          : state.selectedRestaurantDetailsId;

      return {
        ...state,
        selectedRestaurantId: profileKey,
        selectedRestaurantDetailsId: restaurantId,
        // Never validate the next restaurant's time against the previous menu.
        ...(String(profileKey) !== String(state.selectedRestaurantId)
          ? {
              selectedRestaurantData: null,
              selectedRestaurantMenu: null,
              restaurantDetailsLoaded: false,
              restaurantDetailsError: false,
            }
          : {}),
      };
    },
    setSelectedRestaurantDetailsId(state, action) {
      return {
        ...state,
        selectedRestaurantDetailsId: action.payload,
      };
    },
    setSelectedRestaurantData(state, action) {
      return {
        ...state,
        selectedRestaurantData: action.payload,
        restaurantDetailsLoaded: action.payload != null,
      };
    },
    setSelectedRestaurantMenu(state, action) {
      return {
        ...state,
        selectedRestaurantMenu: action.payload,
      };
    },
    setRestaurantDetailsError(state, action) {
      return {
        ...state,
        restaurantDetailsError: action.payload,
      };
    },
  },
});

export const {
  setSelectedRestaurantId,
  setSelectedRestaurantDetailsId,
  setSelectedRestaurantData,
  setSelectedRestaurantMenu,
  setRestaurantDetailsError,
} = mainSlice.actions;

export default mainSlice.reducer;
